
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { ServiceItemProps } from ".";
import { loading, create } from "store/service";
import { AppMessage } from "components";

interface ApiServiceCreateInputProps extends Omit<ServiceItemProps, "id"> {
}

type ApiServiceCreateOutputProps = OutputBaseProps<{ item: ServiceItemProps; }, ApiServiceCreateInputProps>

export const apiServiceCreate = async (data: ApiServiceCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiServiceCreateOutputProps>("/api/service/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};